import { computed, inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilService, VariablesService } from '../../services';
import { isPlatformServer } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  if (isPlatformServer(platformId)) {
    return true; // NEVER redirect on server
  }

  const router = inject(Router);
  const util = inject(UtilService);
  const vars = inject(VariablesService);


  const curUrl = state.url.split('?')[0];
  const user = util.getUser();
  const isPermLogin = computed(() => vars.isPermanentLoggedIn() || user?.login);

  // If logged-in user tries to access signin
  if (isPermLogin() && curUrl.match('signin')) {
    router.navigate([route.queryParams?.['redirect_uri'] || '/'], {
      queryParams: {
        ...route.queryParams,
        redirect_uri: null
      }
    });
    return false;
  }

  // Allow logged in OR accessing signin page
  if (isPermLogin() || curUrl.match('signin')) {
    return true;
  }

  // Else redirect to signin
  const qParams = {
    redirect_uri: curUrl,
    ...route.queryParams
  };

  router.navigate(['/signin'], { queryParams: qParams });
  return false;
};
